import React from "react";
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const EnterpriseHero = () => {
  return (
    <section className="relative py-12 md:py-24 bg-gradient-to-br from-primary/5 to-primary/10 rounded-3xl overflow-hidden">
      <div className="absolute inset-0 bg-grid-white/10 [mask-image:linear-gradient(0deg,transparent,black)]" />
      <div className="relative max-w-5xl mx-auto px-6">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="inline-block bg-primary/10 text-primary rounded-full px-4 py-1.5 text-sm font-medium mb-4">
            Enterprise RL Solutions
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight">
            Reinforcement Learning for Enterprise Agents
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl">
            Architect, train, and govern autonomous agents that deliver
            measurable impact on billion‑dollar KPIs — backed by
            enterprise‑grade security and world‑class RL expertise.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-8">
            <Button size="lg" className="min-w-[200px] primary-button" asChild>
              <Link to="/book-demo">
                <BookOpen className="mr-2" />
                Book an Executive Briefing
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseHero;
